import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin(() => {
    return {
        provide: {
            price: (
                price: number | string,
                locale: string = 'sk-SK',
                currency: string = 'EUR'
            ) =>
                Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency,
                }).format(Number(price)),
        },
    }
})
